import { allSettled } from '@/core/helpers/promise.helpers'
import { getCommonQuestions, getSurveyGroups, getQuestionAnswers, getSurveys, getSurveyData } from '@/services/Survey'
import { getResponses } from '@/services/Response'

/**
 *  Boot tasks
 *
 * @param dispatch
 * @param rootGetters
 *
 * @returns {Promise<any>}
 */
export const boot = ({ dispatch, rootGetters }) => {
  const boot = rootGetters['auth/entitlements'].getAnyPassed({
    'fetchCommonQuestions': { scores: 'read' },
    'fetchResponses': { scores: 'read' },
    'fetchSurveyGroups': { scores: 'read' },
    'fetchSurveys': { scores: 'read' },
    'fetchSurveyData': { scores: 'read' }
  }).map(action => dispatch(action)).map(allSettled)

  return Promise.all(boot)
}

export const fetchCommonQuestions = ({ commit }, data) => {
  return getCommonQuestions(data)
}

export const fetchResponses = ({ commit }, data) => {
  return getResponses(data)
}

export const fetchSurveyGroups = ({ commit }, data) => {
  return getSurveyGroups(data)
}

export const fetchQuestionsAnswers = ({ commit }, data) => {
  return getQuestionAnswers(data)
}

export const fetchSurveys = ({ commit }, data) => {
  return getSurveys()
}

export const fetchSurveyData = ({ commit }, data) => {
  return getSurveyData(data)
}

export default {
  fetchCommonQuestions,
  fetchSurveyGroups,
  fetchResponses,
  fetchSurveys,
  fetchQuestionsAnswers,
  fetchSurveyData
}
